module.exports = __webpack_public_path__ + "img/fr_Ecran 1.9918bc69.png";